import cn from 'classnames'
import React from 'react'

import styles from './SectionTitle.module.scss'

import Divider from '~shared/ui/Divider'
import Flex from '~shared/ui/Flex'
import Text from '~shared/ui/Text'

type SectionTitleProps = React.HTMLAttributes<HTMLDivElement>

function SectionTitle({ children, className, ...props }: React.PropsWithChildren<SectionTitleProps>) {
  return (
    <Flex className={cn(styles.root, className)} align="center" justify="space-between" wrap={false} {...props}>
      <Text as="div" textType="caption" variant="secondary" fontWeight="bold" className={styles.title}>
        {children}
      </Text>
      <Divider variant="default" className={styles.divider} />
    </Flex>
  )
}

export default SectionTitle
